export default __webpack_public_path__ + "6d3fe89365bda35b440c11751884ad77.svg";